import { z } from 'zod/v4';

import { priceQuantityBreaks } from '../visual/common';
import { VisualCustPriceEffect } from '../visual/cust-price-effect';
import { VisualDiscountPrice } from '../visual/discount-price';
import { VisualMarketPrice } from '../visual/market-price';

export const priceBookSchema = z.object({
  ...priceQuantityBreaks,
  key: z.string(),
});

export type PriceBook = z.infer<typeof priceBookSchema>;

export function discountPriceToPriceBook(
  discountPrice: VisualDiscountPrice,
): PriceBook {
  return {
    ...discountPrice,
    key: discountPrice.discount_code,
  };
}

export function custPriceEffectToPriceBook(
  custPriceEffect: VisualCustPriceEffect,
): PriceBook {
  return {
    ...custPriceEffect,
    key: custPriceEffect.customer_id,
  };
}

export function marketPriceToPriceBook(
  marketPrice: VisualMarketPrice,
): PriceBook {
  return {
    ...marketPrice,
    key: marketPrice.market_id,
  };
}
